import React from "react";
import "../css/PrintAllInvoices.css";
import { doctorSettingAtom } from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { getImageURL } from "../../_helper/utils/image";
import { sumByKey } from "../../_helper/utils/utils";

export default function PrintAllInvoices({
  billDate,
  tableData,
  CREDIT_INVOICE,
  filter,
}) {
  const [{ prescription_setup: settings, header_footer_setup }] =
    useAtom(doctorSettingAtom);

  const total_amt = sumByKey(tableData, "invoice_total");
  const recived_amt = sumByKey(tableData, "recieved_payment");
  const pending_amt = sumByKey(tableData, "pending_payment");
  console.log("TOTAL AMOUNT", total_amt);
  return (
    <div className="cu-setup-invoice-summary text-[12px]">
      <div className="print-header">
        <img
          src={getImageURL(header_footer_setup[settings?.pageSize]?.headerUrl)}
          alt="header"
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </div>
      <div className="cu-invoice-summary-title p-5">Invoices</div>

      {/* Left and right flex container */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        {/* Left side (To, GST, PAN) */}
        {/* <div style={{ flex: 1 }}> */}
        {/* <div>
            <span style={{ fontWeight: 700 }}>Bill No: </span>
            <span>{billNo}</span>
          </div> */}
        {/* <div className="cu-institution-name">
            <span style={{ fontWeight: 700 }}>To: </span>
            <span>{institutionName}</span>
          </div>
          <div className="cu-institution-name">
            <span style={{ fontWeight: 700 }}>GST Tin No: </span>
            <span>{gstNo}</span>
          </div>
          <div className="cu-institution-name">
            <span style={{ fontWeight: 700 }}>PAN No: </span>
            <span>{panNo}</span>
          </div> */}
        {/* </div> */}

        {/* Right side (Bill No, Date) */}
        <div style={{ textAlign: "right" }}>
          <div>
            <span style={{ fontWeight: 700 }}>Date: </span>
            <span>{billDate}</span>
          </div>
        </div>
      </div>

      {tableData?.length > 0 && (
        <div className="">
          <table>
            <thead className="cu-setup-invoice-summary-table-header">
              <tr>
                {/* <th className="pl-[10px]">Select</th> */}
                {CREDIT_INVOICE?.tableCols?.map((col) => {
                  if (
                    col?.label !== "Diagnosis" &&
                    col?.label !== "Treatment"
                  ) {
                    if (filter?.institution === "true") {
                      return <th key={col?.id}>{col?.label}</th>;
                    } else {
                      if (
                        col?.label !== "Customer" &&
                        col?.label !== "Due Date"
                      ) {
                        return <th key={col?.id}>{col?.label}</th>;
                      }
                    }
                  }
                })}
              </tr>
            </thead>
            <tbody>
              {tableData?.map((trow, i) => {
                return (
                  <tr key={i}>
                    {/* <td className="pl-[10px]">
                        <input
                          type="checkbox"
                          checked={isRowSelected(trow?.id)}
                          onChange={(event) =>
                            handleCheckboxChange(event, trow)
                          }
                        />
                      </td> */}
                    {Object.keys(trow)?.map((key, idx) => {
                      return (
                        key !== "id" &&
                        key !== "email" &&
                        key !== "invoice_pdf" &&
                        key !== "customerId" &&
                        (key === "invoice_number" ? (
                          <td key={idx}>{trow[key]}</td>
                        ) : key === "customer" ? (
                          <td key={idx}>{trow[key]}</td>
                        ) : (
                          <td key={idx}>{trow[key]}</td>
                        ))
                      );
                    })}
                  </tr>
                );
              })}
              {/* In Words and Prepared By row */}
              <tr>
                <td colSpan={3} style={{ fontWeight: 700 }}>
                  Total Amount : {total_amt}
                </td>
                {/* <td
                  colSpan={2}
                  style={{ fontWeight: 700, textAlign: "center" }}
                >
                  For Chaitanya Multispeciality Hospital
                </td> */}
                <td
                  colSpan={3}
                  style={{
                    fontWeight: 700,
                    textAlign: "center",
                    color: "green",
                  }}
                >
                  Recived : {recived_amt}
                </td>
                <td
                  colSpan={3}
                  style={{ fontWeight: 700, textAlign: "center", color: "red" }}
                >
                  Pending : {pending_amt}
                </td>
              </tr>
              <tr>
                <td
                  colSpan={9}
                  style={{
                    fontWeight: 700,
                    height: "120px",
                    textAlign: "left",
                    padding: "10px",
                  }}
                >
                  Prepared By:
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      <div
        style={{
          width: "100%",
          fontWeight: 700,
          textAlign: "center",
          padding: "10px 0",
        }}
      >
        "Note: This is a system-generated invoice and does not require a
        signature."
      </div>
    </div>
  );
}
